module.exports = __webpack_public_path__ + "img/exclamationmark-triangle_fill.66129f80.svg";